import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { StackOutput } from "types/generated";

type OutputWithStack = StackOutput & {
  stackId: string;
  stackName: string;
};

const TemplateDeploymentOutputsDropdownActionsCell = (
  cellProps: TableSimpleCellProps<OutputWithStack>
) => {
  return <TableSimpleCell {...cellProps} />;
};

export default TemplateDeploymentOutputsDropdownActionsCell;
